var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgErlang = function SvgErlang(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#erlang_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A90533",
    d: "M2.611 13.288C1.37 11.972.642 10.154.645 7.985c-.003-1.918.6-3.567 1.637-4.821H.102v10.125h2.51v-.001Zm11.47 0a10.405 10.405 0 0 0 1.449-2.02l-2.41-1.2c-.847 1.377-2.085 2.644-3.797 2.652-2.491-.008-3.47-2.139-3.465-4.881h9.31a4.65 4.65 0 0 0 0-.603c.061-1.631-.371-3.003-1.158-4.07l-.004.002h2.096v10.12h-2.02Zm-8.073-7.8a2.215 2.215 0 0 1 2.23-2.078c1.15.002 1.99.837 2.02 2.079h-4.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "erlang_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErlang);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;